import classNames from 'classnames'
import { JSX, useState } from 'react'

import { Button } from 'core-components/library/button'

import styles from './Actions.module.scss'

export interface IActionsProps {
  className?: string
  position?: 'start' | 'center' | 'end'
  items: IItem[]
}

interface IItem {
  id: string
  label: string | JSX.Element
  variant?: 'contained' | 'outlined' | 'text'
  color?: 'primary' | 'success' | 'warning' | 'danger' | 'white' | 'grey'
  disabled?: boolean
  icon?: string
  onClick: () => void | Promise<void>
  /**
   * Button test ID. This property is used for automated tests.
   */
  __testId?: string
}

export const Actions = ({ className, position = 'end', items }: IActionsProps) => {
  const [processingItemId, setProcessingItemId] = useState<IItem['id'] | null>(null)

  return (
    <div
      data-testid={'actions_container'}
      className={classNames(styles.root, styles[`root--pos-${position}`], className || '')}
    >
      {items.map((item) => (
        <Button
          key={item.id}
          __testId={item.__testId}
          className={styles.item}
          variant={item.variant}
          color={item.color}
          icon={item.icon}
          loading={processingItemId === item.id}
          disabled={item.disabled || (!!processingItemId && processingItemId !== item.id)}
          onClick={async () => {
            setProcessingItemId(item.id)
            await item.onClick()
            setProcessingItemId(null)
          }}
        >
          {item.label}
        </Button>
      ))}
    </div>
  )
}
